export const GET_STATES = 'GET_STATES';
export const SET_STATES = 'SET_STATES';
export const API_ERROR = 'LOGIN_API_ERROR';